import { render, staticRenderFns } from "./SchedulingConflictsCard.vue?vue&type=template&id=2dcf8e71&scoped=true&"
import script from "./SchedulingConflictsCard.vue?vue&type=script&lang=js&"
export * from "./SchedulingConflictsCard.vue?vue&type=script&lang=js&"
import style0 from "./SchedulingConflictsCard.vue?vue&type=style&index=0&id=2dcf8e71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcf8e71",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemActionText } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VContainer,VList,VListItem,VListItemAction,VListItemActionText,VListItemContent,VListItemSubtitle,VSheet,VSubheader})
